/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ActiveProfileSnapshotDto } from "./ActiveProfileSnapshotDto";
import {
    ActiveProfileSnapshotDtoFromJSON,
    ActiveProfileSnapshotDtoFromJSONTyped,
    ActiveProfileSnapshotDtoToJSON,
} from "./ActiveProfileSnapshotDto";

/**
 *
 * @export
 * @interface DistributionBoardSnapshotDto
 */
export interface DistributionBoardSnapshotDto {
    /**
     *
     * @type {string}
     * @memberof DistributionBoardSnapshotDto
     */
    uniqueId?: string;
    /**
     *
     * @type {Date}
     * @memberof DistributionBoardSnapshotDto
     */
    date?: Date;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    externalLoadL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    externalLoadL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    externalLoadL3Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    connectorsAssignedL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    connectorsAssignedL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    connectorsAssignedL3Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    feedbackConnectorsLoadL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    feedbackConnectorsLoadL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    feedbackConnectorsLoadL3Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    feedbackExternalLoadL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    feedbackExternalLoadL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    feedbackExternalLoadL3Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    operatingCapacityL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    operatingCapacityL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshotDto
     */
    operatingCapacityL3Amps?: number;
    /**
     *
     * @type {Array<ActiveProfileSnapshotDto>}
     * @memberof DistributionBoardSnapshotDto
     */
    activeProfileSnapshots?: Array<ActiveProfileSnapshotDto>;
}

/**
 * Check if a given object implements the DistributionBoardSnapshotDto interface.
 */
export function instanceOfDistributionBoardSnapshotDto(
    value: object,
): value is DistributionBoardSnapshotDto {
    return true;
}

export function DistributionBoardSnapshotDtoFromJSON(
    json: any,
): DistributionBoardSnapshotDto {
    return DistributionBoardSnapshotDtoFromJSONTyped(json, false);
}

export function DistributionBoardSnapshotDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DistributionBoardSnapshotDto {
    if (json == null) {
        return json;
    }
    return {
        uniqueId: json["uniqueId"] == null ? undefined : json["uniqueId"],
        date: json["date"] == null ? undefined : new Date(json["date"]),
        externalLoadL1Amps:
            json["externalLoadL1Amps"] == null
                ? undefined
                : json["externalLoadL1Amps"],
        externalLoadL2Amps:
            json["externalLoadL2Amps"] == null
                ? undefined
                : json["externalLoadL2Amps"],
        externalLoadL3Amps:
            json["externalLoadL3Amps"] == null
                ? undefined
                : json["externalLoadL3Amps"],
        connectorsAssignedL1Amps:
            json["connectorsAssignedL1Amps"] == null
                ? undefined
                : json["connectorsAssignedL1Amps"],
        connectorsAssignedL2Amps:
            json["connectorsAssignedL2Amps"] == null
                ? undefined
                : json["connectorsAssignedL2Amps"],
        connectorsAssignedL3Amps:
            json["connectorsAssignedL3Amps"] == null
                ? undefined
                : json["connectorsAssignedL3Amps"],
        feedbackConnectorsLoadL1Amps:
            json["feedbackConnectorsLoadL1Amps"] == null
                ? undefined
                : json["feedbackConnectorsLoadL1Amps"],
        feedbackConnectorsLoadL2Amps:
            json["feedbackConnectorsLoadL2Amps"] == null
                ? undefined
                : json["feedbackConnectorsLoadL2Amps"],
        feedbackConnectorsLoadL3Amps:
            json["feedbackConnectorsLoadL3Amps"] == null
                ? undefined
                : json["feedbackConnectorsLoadL3Amps"],
        feedbackExternalLoadL1Amps:
            json["feedbackExternalLoadL1Amps"] == null
                ? undefined
                : json["feedbackExternalLoadL1Amps"],
        feedbackExternalLoadL2Amps:
            json["feedbackExternalLoadL2Amps"] == null
                ? undefined
                : json["feedbackExternalLoadL2Amps"],
        feedbackExternalLoadL3Amps:
            json["feedbackExternalLoadL3Amps"] == null
                ? undefined
                : json["feedbackExternalLoadL3Amps"],
        operatingCapacityL1Amps:
            json["operatingCapacityL1Amps"] == null
                ? undefined
                : json["operatingCapacityL1Amps"],
        operatingCapacityL2Amps:
            json["operatingCapacityL2Amps"] == null
                ? undefined
                : json["operatingCapacityL2Amps"],
        operatingCapacityL3Amps:
            json["operatingCapacityL3Amps"] == null
                ? undefined
                : json["operatingCapacityL3Amps"],
        activeProfileSnapshots:
            json["activeProfileSnapshots"] == null
                ? undefined
                : (json["activeProfileSnapshots"] as Array<any>).map(
                      ActiveProfileSnapshotDtoFromJSON,
                  ),
    };
}

export function DistributionBoardSnapshotDtoToJSON(
    value?: DistributionBoardSnapshotDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        uniqueId: value["uniqueId"],
        date: value["date"] == null ? undefined : value["date"].toISOString(),
        externalLoadL1Amps: value["externalLoadL1Amps"],
        externalLoadL2Amps: value["externalLoadL2Amps"],
        externalLoadL3Amps: value["externalLoadL3Amps"],
        connectorsAssignedL1Amps: value["connectorsAssignedL1Amps"],
        connectorsAssignedL2Amps: value["connectorsAssignedL2Amps"],
        connectorsAssignedL3Amps: value["connectorsAssignedL3Amps"],
        feedbackConnectorsLoadL1Amps: value["feedbackConnectorsLoadL1Amps"],
        feedbackConnectorsLoadL2Amps: value["feedbackConnectorsLoadL2Amps"],
        feedbackConnectorsLoadL3Amps: value["feedbackConnectorsLoadL3Amps"],
        feedbackExternalLoadL1Amps: value["feedbackExternalLoadL1Amps"],
        feedbackExternalLoadL2Amps: value["feedbackExternalLoadL2Amps"],
        feedbackExternalLoadL3Amps: value["feedbackExternalLoadL3Amps"],
        operatingCapacityL1Amps: value["operatingCapacityL1Amps"],
        operatingCapacityL2Amps: value["operatingCapacityL2Amps"],
        operatingCapacityL3Amps: value["operatingCapacityL3Amps"],
        activeProfileSnapshots:
            value["activeProfileSnapshots"] == null
                ? undefined
                : (value["activeProfileSnapshots"] as Array<any>).map(
                      ActiveProfileSnapshotDtoToJSON,
                  ),
    };
}
